export const COMPLETE_ETC_NATIONS_TEXT = `Please show your purchases and your\nMobile tax refund receipt to customs.\nThen we'll send an email to request your information\nfor processing refunds within 10 days.\nPlease check your mailbox.`;
export const COMPLETE_MAIN_NATIONS_TEXT = `Please show your purchases and your\nMobile tax refund receipt to customs.\nThen we’ll transfer your refund amount\nto the information you provided within 21 business days.`;
export const COMPLETE_CASH_PICKUP_TEXT = `Show your items and submit your printed refund receipt to Customs.\nThen you can pick up your refund at Western Union after about 1-2 months.`;
export const COMPLETE_FORCE_CRUISE_TEXT = `Show your items and submit your printed refund receipt to Customs. Refund will be sent within 1-2 months once verified.`;

export const COMPLETE_FORCE_TEXT_KOR =
  '환급전표를 출력하고\n세관 도장을 받으세요.';
export const COMPLETE_TEXT_KOR =
  '구매한 물품과 출력된 환급 영수증을 세관에 제시하세요. 세관 확인 후 21영업일 이내에 환급금이 송금됩니다.';

export const COMPLETE_TEXTS = {
  COMPLETE_ETC_NATIONS_TEXT,
  COMPLETE_MAIN_NATIONS_TEXT,
  COMPLETE_CASH_PICKUP_TEXT,
  COMPLETE_FORCE_CRUISE_TEXT,
  COMPLETE_FORCE_TEXT_KOR,
  COMPLETE_TEXT_KOR,
};
